import {Helmet} from "react-helmet";
import React from "react";
import logo from "../../../../assets/images/logo.png";
import './RefundForm.scss';


const RefundForm = () => {

  return (
    <>
      <Helmet>
        <title>Formulário de Reembolso</title>
      </Helmet>
      <div className="RefundForm">
        <div className="navbar">
          <img src={logo} alt="Logo" style={{ height: '100%' }} />
        </div>

        <div className="content">
          <h1 className={"header"}>Formulário de Reembolso</h1>
          <>
            <>
              <table
                cellSpacing={0}
                cellPadding={0}
                style={{
                  width: "451pt",
                  border: "1pt solid #000000",
                  borderCollapse: "collapse"
                }}
              >
                <tbody>
                <tr style={{ height: "21pt" }}>
                  <td
                    colSpan={2}
                    style={{
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        textAlign: "center",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      <strong>FORMULÁRIO DE REEMBOLSO</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Nome do evento:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Número da inscrição:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Nome do beneficiário:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      CPF/ CNPJ:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Banco:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Agência:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Número da conta:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
                      Tipo de conta:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginLeft: "36pt",
                        marginBottom: "0pt",
                        textIndent: "-18pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
            <span
              style={{
                width: "18pt",
                font: '7pt "Times New Roman"',
                display: "inline-block"
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
                      Poupança
                    </p>
                    <p
                      style={{
                        marginTop: "0pt",
                        marginLeft: "36pt",
                        marginBottom: "0pt",
                        textIndent: "-18pt",
                        lineHeight: "115%",
                        fontSize: "11pt"
                      }}
                    >
            <span
              style={{
                width: "18pt",
                font: '7pt "Times New Roman"',
                display: "inline-block"
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
                      Corrente
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      Possui PIX nesta conta?
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginLeft: "36pt",
                        marginBottom: "0pt",
                        textIndent: "-18pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
            <span
              style={{
                width: "18pt",
                font: '7pt "Times New Roman"',
                display: "inline-block"
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
                      Sim
                    </p>
                    <p
                      style={{
                        marginTop: "0pt",
                        marginLeft: "36pt",
                        marginBottom: "0pt",
                        textIndent: "-18pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
            <span
              style={{
                width: "18pt",
                font: '7pt "Times New Roman"',
                display: "inline-block"
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
                      Não
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      Se sim, informe o tipo de chave PIX:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderRightStyle: "solid",
                      borderRightWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      Valor:
                    </p>
                  </td>
                  <td
                    style={{
                      borderTopStyle: "solid",
                      borderTopWidth: "1pt",
                      borderLeftStyle: "solid",
                      borderLeftWidth: "1pt",
                      padding: "5pt 4.5pt",
                      verticalAlign: "top"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        widows: 0,
                        orphans: 0,
                        fontSize: "11pt"
                      }}
                    >
                      &nbsp;
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
              <p style={{ marginTop: "0pt", marginBottom: "0pt" }}>&nbsp;</p>
            </>

          </>

        </div>
      </div>
    </>
  );
}

export default RefundForm;